import { useNavigate } from "react-router-dom";

function Button({ btnContent, onclickHandler }) {
  const navigate = useNavigate();
  return (
    <div className="">
      <button
        onClick={onclickHandler}
        className="p-2 px-4 rounded-md md:rounded-3xl 2xl:text-xl 2xl:p-3 2xl:px-6 bg-[#006A4E] text-white"
      >
        {btnContent}
      </button>
    </div>
  );
}

export default Button;